import config from 'admin-panel/config/environment';

const {
  api: { namespace },
} = config;

type PageResponsePayload = {
  meta?: Record<string, unknown>;
};

export function addRequestLocaleToPagePayload(
  payload: PageResponsePayload | undefined,
  url: string | undefined
) {
  const localeKey = localeFromPageUrl(url);

  if (!payload || !localeKey) {
    return;
  }

  payload.meta = {
    ...payload.meta,
    locale: localeKey,
  };
}

function localeFromPageUrl(url: string | undefined) {
  if (!url) return null;

  const match = new RegExp(
    `/${escapeRegExp(namespace)}/([^/?#]+)/pages(?:[/?#]|$)`
  ).exec(url);

  return match?.[1] ?? null;
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
